import {
  LOGININ,
  LOGINOUT
} from "../actions";


const fetchReducer = (state: any, action: any) => {
  switch (action.type) {
    case LOGININ:
      return Object.assign({}, state, {
        login: true,
        count: state.count + 1
      });
    case LOGINOUT:
      return Object.assign({}, state, {
        login: false,
      });
    default:
      return state;
  }
};

export {
  fetchReducer
}